import React from "react";
import {Button as RNButton, Text, View,} from "react-native";
import MenuButton from "../components/MenuButton";
import {RepositColours, RepositStyles} from "../utils/styles";
import goTo from "../utils/goTo";
import WebHeading from "../components/WebHeading";

class ConnectionType extends React.Component {
  static navigationOptions = {
    headerRight: <MenuButton />,
    title: "New Setup",
  };
  render() {
    return (
      <View style={RepositStyles.wrapper}>
        <WebHeading title="Box Replacement" />
        <View style={{ flex: 1, alignItems: "center" }}>
          <View style={{ flex: 1, maxWidth: 800, maxHeight: 600 }}>
            <View style={{ flex: 2, justifyContent: "center" }}>
              <Text style={RepositStyles.headerText}>Network Connection</Text>
            </View>
            <View style={{ flex: 2 }}>
              <Text style={RepositStyles.paragraphText}>
                Select the type of connection between the Reposit Box and the
                customer's internet
              </Text>
            </View>
            <View style={{ flex: 2, justifyContent: "center" }}>
              <RNButton
                title="Wired"
                color={RepositColours.blue}
                onPress={() => {
                  goTo(this.props.navigation, "WiredConnection");
                }}
              />
            </View>
            <View style={{ flex: 2, justifyContent: "center" }}>
              <RNButton
                title="Wireless"
                color={RepositColours.blue}
                onPress={() => {
                  goTo(this.props.navigation, "WirelessConnection");
                }}
              />
            </View>
            <View style={{ flex: 5 }} />
          </View>
        </View>
      </View>
    );
  }
}

export default ConnectionType;



// WEBPACK FOOTER //
// ./src/containers/ConnectionType.js